import { render, staticRenderFns } from "./publicationSuccess.vue?vue&type=template&id=a61be12c&scoped=true&"
import script from "./publicationSuccess.vue?vue&type=script&lang=js&"
export * from "./publicationSuccess.vue?vue&type=script&lang=js&"
import style0 from "./publicationSuccess.vue?vue&type=style&index=0&id=a61be12c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a61be12c",
  null
  
)

export default component.exports